<template>
  <div
    v-if="isShowing"
    ref="interactElement"
    :class="{
      isAnimating: isInteractAnimating,
      isCurrent: isCurrent,
      [card.id]: true,
    }"
    class="card"
    :style="{ transform: transformString }"
  >
    <div v-if="card.id !== 'game'">
      <p v-for="sentence in card.sentences" class="cardTitle" :key="sentence">
        {{ sentence }}
      </p>
      <button class="next" @click="next">
        Next
      </button>
    </div>
    <div v-else class="game-container">
      <Board :grid="grid" ref="board"></Board>
    </div>
  </div>
</template>

<script>
// import interact from "interactjs";
import Board from "./Board";

const ACCEPT_CARD = "cardAccepted";
const REJECT_CARD = "cardRejected";
const SKIP_CARD = "cardSkipped";

export default {
  components: { Board },
  static: {
    interactMaxRotation: 15,
    interactOutOfSightXCoordinate: 500,
    interactOutOfSightYCoordinate: 600,
    interactYThreshold: 150,
    interactXThreshold: 100,
  },

  props: {
    grid: {
      type: Object,
      required: true,
    },
    card: {
      type: Object,
      required: true,
    },
    isCurrent: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      isShowing: true,
      isInteractAnimating: true,
      isInteractDragged: null,
      interactPosition: {
        x: 0,
        y: 0,
        rotation: 0,
      },
    };
  },

  computed: {
    transformString() {
      if (!this.isInteractAnimating || this.isInteractDragged) {
        const { x, y, rotation } = this.interactPosition;
        return `translate3D(${x}px, ${y}px, 0) rotate(${rotation}deg)`;
      }

      return null;
    },
  },

  mounted() {
    const element = this.$refs.interactElement;
    if (element && this.card.id !== "game") {
      // interact(element).draggable({
      //   onstart: () => {
      //     this.isInteractAnimating = false;
      //   },
      //   onmove: (event) => {
      //     const {
      //       interactMaxRotation,
      //       interactXThreshold,
      //     } = this.$options.static;
      //     const x = this.interactPosition.x + event.dx;
      //     const y = this.interactPosition.y + event.dy;
      //     let rotation = interactMaxRotation * (x / interactXThreshold);
      //     if (rotation > interactMaxRotation) rotation = interactMaxRotation;
      //     else if (rotation < -interactMaxRotation)
      //       rotation = -interactMaxRotation;
      //     this.interactSetPosition({ x, y, rotation });
      //   },
      //   onend: () => {
      //     const { x, y } = this.interactPosition;
      //     const {
      //       interactXThreshold,
      //       interactYThreshold,
      //     } = this.$options.static;
      //     this.isInteractAnimating = true;
      //     if (x > interactXThreshold) this.playCard(ACCEPT_CARD);
      //     else if (x < -interactXThreshold) this.playCard(REJECT_CARD);
      //     else if (y > interactYThreshold) this.playCard(SKIP_CARD);
      //     else this.resetCardPosition();
      //   },
      // });
    }
  },

  beforeDestroy() {
    // interact(this.$refs.interactElement).unset();
  },

  methods: {
    next() {
      this.playCard(REJECT_CARD);
    },

    hideCard() {
      setTimeout(() => {
        this.isShowing = false;
        this.$emit("hideCard", this.card);
      }, 300);
    },

    playCard(interaction) {
      const {
        interactOutOfSightXCoordinate,
        interactOutOfSightYCoordinate,
        interactMaxRotation,
      } = this.$options.static;

      this.interactUnsetElement();

      switch (interaction) {
        case ACCEPT_CARD:
          this.interactSetPosition({
            x: interactOutOfSightXCoordinate,
            rotation: interactMaxRotation,
          });
          this.$emit(ACCEPT_CARD);
          break;
        case REJECT_CARD:
          this.interactSetPosition({
            x: -interactOutOfSightXCoordinate,
            rotation: -interactMaxRotation,
          });
          this.$emit(REJECT_CARD);
          break;
        case SKIP_CARD:
          this.interactSetPosition({
            y: interactOutOfSightYCoordinate,
          });
          this.$emit(SKIP_CARD);
          break;
      }

      this.hideCard();
    },

    interactSetPosition(coordinates) {
      const { x = 0, y = 0, rotation = 0 } = coordinates;
      this.interactPosition = { x, y, rotation };
    },

    interactUnsetElement() {
      // interact(this.$refs.interactElement).unset();
      this.isInteractDragged = true;
    },

    resetCardPosition() {
      this.interactSetPosition({ x: 0, y: 0, rotation: 0 });
    },
  },
};
</script>

<style scoped>
.card {
  border-radius: 15px;
  box-shadow: 0 30px 30px 0 rgba(0, 0, 0, 0.05);
  position: absolute;
  top: 0;
  width: 100%;
  height: 80%;
  display: flex;
  align-items: center;
  justify-content: center;
  display: flex;
  /* max-height: 650px; */
  margin: auto;
  font-size: 24px;
  font-weight: 700;
  color: white;
  background-image: linear-gradient(-180deg, #d94e47 2%, #df1165 100%);
  opacity: 0;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  user-select: none;
  pointer-events: none;
  will-change: transform, opacity;
  display: flex;
  flex-direction: column;
  padding: 5rem;
  box-sizing: border-box;
  font-size: 1rem;
  min-height: 80%;
}

.gameStarted .card {
  margin: 0;
  height: auto;
}

@media screen and (min-width: 1000px) {
  .card {
    font-size: 3rem;
  }
}

.card.isCurrent {
  pointer-events: auto;
}

.card.isAnimating {
  transition: transform 0.7s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.card::after {
  content: "";
  margin: auto;
  border-radius: 100px;
  background: rgba(black, 0.3);
  width: 21px;
  height: 3px;
  position: absolute;
  right: 0;
  left: 0;
  bottom: 11px;
}

.cardTitle {
  margin: 0 0 15px;
  /* font-size: $fs-card-title; */
}

.card:nth-child(1) {
  transform: translateY(0);
}

.card:nth-child(2) {
  transform: translateY(20px);
}

.card:nth-child(3) {
  transform: translateY(40px);
}

.card:nth-child(4) {
  transform: translateY(60px);
}

.intro {
  z-index: 3;
  opacity: 1;
  color: white;
}

.drag {
  z-index: 2;
  opacity: 1;
  background: #73345e;
}

.go {
  z-index: 1;
  opacity: 1;
  background: #432958;
}

.game {
  z-index: 0;
  opacity: 0;
  background: transparent;
  box-shadow: none;
  padding: 0;
  position: relative;
}

.game.isCurrent {
  opacity: 1;
}

.next {
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
    0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
  color: #fff;
  background-color: #1976d2;
  padding: 6px 16px;
  font-size: 0.875rem;
  min-width: 64px;
  box-sizing: border-box;
  transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
    box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
    border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  font-weight: 500;
  line-height: 1.75;
  border-radius: 5px;
  letter-spacing: 0.02857em;
  text-transform: uppercase;
  border: none;
  cursor: pointer;
  position: absolute;
  bottom: 1rem;
  right: 1rem;
  opacity: 0;
  transition: 0.4s opacity;
}

.isCurrent {
  transform: translateY(0);
}

.isCurrent .next {
  opacity: 1;
}

.next:hover {
  background-color: rgb(17, 82, 147);
}

.next:active {
  box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2),
    0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
}

.game-container {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  overflow: hidden;
}
</style>
